// @flow
import * as React from 'react'
import { WhitelabelContext } from 'main/framework'
import ContentWidthConstraint from 'ui/ContentWidthConstraint'
import Link from 'ui/Link'
import Grid, { GridCell } from 'ui/Grid'
import { AssetName } from 'main/util/asset'
import './PageFooter.scss'

type Props = {
  showPartnerButton: boolean,
}

export default class PageFooter extends React.Component<Props> {
  static contextType = WhitelabelContext
  static defaultProps = {
    showPartnerButton: true,
  }

  render = () => {
    return (
      this.context.showByDefaultExceptIfFalse(AssetName.FOOTER) && (
        <footer className="PageFooter">
          <ContentWidthConstraint>
            <Grid full>
              <GridCell>{renderRegionLinks()}</GridCell>
              <GridCell>{renderSocialLinks()}</GridCell>
              <GridCell>{renderMiscLinks()}</GridCell>
              <GridCell>{renderContactLinks()}</GridCell>
              {/* renderPartnerCta(this.props.showPartnerButton) */}
            </Grid>
          </ContentWidthConstraint>
        </footer>
      )
    )
  }
}

function renderRegionLinks() {
  return (
    <div>
      <div className="PageFooter-linkListTitle">Child Care Near You</div>

      <FooterLink href="/ca/berkeley">Berkeley, CA</FooterLink>
      <br />
      <FooterLink href="/ny/bronx">Bronx, NY</FooterLink>
      <br />
      <FooterLink href="/ny/brooklyn">Brooklyn, NY</FooterLink>
      <br />
      <FooterLink href="/tx/dallas">Dallas, TX</FooterLink>
      <br />
      <FooterLink href="/co/denver">Denver, CO</FooterLink>
      <br />
      <FooterLink href="/tx/houston">Houston, TX</FooterLink>
      <br />
      <FooterLink href="/ca/irvine">Irvine, CA</FooterLink>
      <br />
      <FooterLink href="/ca/los-angeles">Los Angeles, CA</FooterLink>
      <br />
      <FooterLink href="/ny/new-york">New York, NY</FooterLink>
      <br />
      <FooterLink href="/ca/oakland">Oakland, CA</FooterLink>
      <br />
      <FooterLink href="/ca/richmond">Richmond, CA</FooterLink>
      <br />
      <FooterLink href="/ca/san-francisco">San Francisco, CA</FooterLink>
      <br />
      <FooterLink href="/ca/san-jose">San Jose, CA</FooterLink>
      <br />
      <FooterLink href="/ca/san-mateo">San Mateo, CA</FooterLink>
      <br />
      <FooterLink href="/locations">All Locations</FooterLink>
    </div>
  )
}

function renderSocialLinks() {
  return (
    <div>
      <div className="PageFooter-linkListTitle">Follow Us</div>

      <FooterLink href="https://www.wonderschool.com/p/parent-resources/" target="_blank">
        Parent Resources
      </FooterLink>
      <br />
      <FooterLink
        href="https://www.wonderschool.com/p/child-care-provider-resources/"
        target="_blank"
      >
        Director Resources
      </FooterLink>
      <br />
      <FooterLink href="https://blog.wonderschool.com" target="_blank">
        Company Blog
      </FooterLink>
      <br />
      <FooterLink href="https://www.facebook.com/joinwonderschool" target="_blank">
        Facebook
      </FooterLink>
      <br />
      <FooterLink href="https://instagram.com/wonderschools" target="_blank">
        Instagram
      </FooterLink>
      <br />
      <FooterLink href="https://twitter.com/wonderschools" target="_blank">
        Twitter
      </FooterLink>
    </div>
  )
}

function renderMiscLinks() {
  return (
    <div>
      <div className="PageFooter-linkListTitle">Wonderschool</div>

      <FooterLink href="/vision">Our Vision</FooterLink>
      <br />
      <FooterLink href="/company">About Us</FooterLink>
      <br />
      <FooterLink href="https://boards.greenhouse.io/wonderschool" target="_blank">
        Jobs
      </FooterLink>
      <br />
      <FooterLink href="https://wonderschool.zendesk.com/hc/en-us" target="_blank">
        Help
      </FooterLink>
      <br />
      <FooterLink href="mailto:press@wonderschool.com">Press</FooterLink>
      <br />
      <FooterLink href="/terms-of-use">Terms of Use</FooterLink>
      <br />
      <FooterLink href="/privacy-policy">Privacy Policy</FooterLink>
      <br />
      <FooterLink href="https://try.wonderschool.com/for-business/">For business</FooterLink>
    </div>
  )
}

function renderContactLinks() {
  return (
    <div>
      <div className="PageFooter-linkListTitle">Contact us</div>

      <FooterLink href="mailto:hello@wonderschool.com">Email us</FooterLink>
    </div>
  )
}

type FooterLinkProps = {
  children: React.Node,
}

function FooterLink({ children, ...props }: FooterLinkProps) {
  return (
    <Link {...props} blend>
      {children}
    </Link>
  )
}
